import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { TABBY_WIDGET_MERCHANT_CODE, TABBY_WIDGET_PUBLIC_KEY } from "@globalConfig";
import { Dialog, DialogContent } from "@/components/Dialog/Dialog";
import { Drawer, DrawerContent } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
var TabbyModal = function TabbyModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? 100 : _ref$price,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? "SAR" : _ref$currency;
  var isMobile = useIsMobile();
  var lang = useLang();

  // Lock body scroll when drawer is open
  useEffect(function () {
    if (isOpen && isMobile) {
      document.body.style.overflow = "hidden";
      return function () {
        document.body.style.overflow = "";
      };
    }
  }, [isOpen, isMobile]);
  var tabbyUrl = lang === "ar" ? "https://checkout.tabby.ai/promos/product-page/installments/ar/?price=".concat(price, "&currency=").concat(currency, "&merchant_code=").concat(TABBY_WIDGET_MERCHANT_CODE, "&public_key=").concat(TABBY_WIDGET_PUBLIC_KEY) : "https://checkout.tabby.ai/promos/product-page/installments/en/?price=".concat(price, "&currency=").concat(currency, "&merchant_code=").concat(TABBY_WIDGET_MERCHANT_CODE, "&public_key=").concat(TABBY_WIDGET_PUBLIC_KEY);
  var content = /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 flex items-center justify-between p-4 py-3 border-b border-solid border-gray-200"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-20 h-10"
  }), /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClose,
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClose();
      }
    },
    className: "bg-transparent border-none cursor-pointer",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: tabbyUrl,
    title: "Tabby Payment Info",
    className: "w-full border-none",
    style: {
      height: isMobile ? "calc(100vh - 60px)" : "100%"
    }
  })));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Drawer, {
      open: isOpen,
      onOpenChange: function onOpenChange(open) {
        return !open && onClose();
      },
      snapPoints: [1],
      fadeFromIndex: 0,
      modal: false,
      handleOnly: true
    }, /*#__PURE__*/React.createElement(DrawerContent, {
      className: "bg-white flex flex-col rounded-t-[16px] !max-h-full h-full fixed bottom-0 left-0 right-0 z-[99999] !mt-0"
    }, content));
  }
  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-[560px] md:max-w-[600px] w-[90vw] max-h-[95vh] p-0 overflow-hidden h-full md:rounded-[35px]",
    haveClose: false,
    overlayClassName: "z-[9999]"
  }, content));
};
export default TabbyModal;